export default __webpack_public_path__ + "static/media/Keyword_Label.4f57ce36.svg";